import * as React from 'react';

import { cn } from '@/lib/utils';

const Input = ({ ref, className, type, ...props }: React.ComponentPropsWithRef<'input'>) => {
  return (
    <input
      type={type}
      className={cn(
        'flex h-10 w-full rounded-xl border border-content-highlight bg-input px-3 py-2 text-base ring-offset-background file:border-2 file:border-gray-600 file:bg-transparent file:text-sm file:font-medium file:text-white text-white file:cursor-pointer placeholder:text-muted-foreground focus-visible:outline-hidden focus-visible:border-white focus-visible:ring-ring focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        className,
      )}
      ref={ref}
      {...props}
    />
  );
};
Input.displayName = 'Input';

export { Input };
